import { TbAspectRatio } from 'react-icons/tb';
import { MdOutlineCalendarMonth } from 'react-icons/md';
import { BsReverseListColumnsReverse } from 'react-icons/bs';
import { RenderTiles } from '../../../components/common';
import ChildHeader from '../../../components/ui/ChildHeader';
import { tilesConstant } from './helpers/constant';

const tiles = [
  {
    sNo: 1,
    link: '/common/toolPreventiveMaintenancePlanNewPlanList',
    isLink: true,
    icon: <MdOutlineCalendarMonth size="5rem" color="#343a40" />,
    p: 'Tool Preventive Maintenance',
    span: 'PLAN',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/toolPreventiveMaintenancePlanNewStatus',
    isLink: true,
    icon: <BsReverseListColumnsReverse size="5rem" color="#087f5b" />,
    p: 'Tool Preventive Maintenance',
    span: 'STATUS',
    isIcon: true,
  },
  // {
  //   sNo: 2,
  //   link: '/common/revalidationChecklist',
  //   isLink: true,
  //   icon: <TbAspectRatio size="5rem" color="#343a40" />,
  //   p: 'Plan',
  //   span: 'Checklists',
  //   isIcon: true,
  // },
];

const Tiles = () => {
  return (
    <>
      <ChildHeader text={tilesConstant.childHeaderText} />
      <RenderTiles
        tilesObj={tiles}
        justify="start"
        height="100vh"
        columns="0fr"
      />
    </>
  );
};

export default Tiles;
